
export interface PollVoteRequest {
  /** 투표할 옵션 ID */
  optionId: string;
}
